import { useEffect, useRef, useState } from "react";

// true, sobald das Element nahe am sichtbaren Bereich ist (ohne IntersectionObserver sofort) – Bilder unterhalb des Falzes laden so erst beim Scrollen
export const useNear = (margin = "250px") => {
  const ref = useRef(null);
  const [near, setNear] = useState(typeof IntersectionObserver === "undefined");
  useEffect(() => {
    const el = ref.current;
    if (near || !el) return undefined;
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { setNear(true); io.disconnect(); }
    }, { rootMargin: `${margin} 0px` });
    io.observe(el);
    return () => io.disconnect();
  }, [near, margin]);
  return [ref, near];
};
